function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import App from 'modules/App';
import Select from 'components/Form/Select';
import messages from 'modules/App/messages';
import styles from './PerPageSelect.pcss';
var _React_PureComponent;
class PerPageSelect extends (_React_PureComponent = React.PureComponent) {
    render() {
        const { onChange, value } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.perPageSelect,
            children: [
                /*#__PURE__*/ _jsxs("label", {
                    className: "label",
                    htmlFor: "perPageSelect",
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.rowsPerPage)),
                        ":"
                    ]
                }),
                /*#__PURE__*/ _jsx(Select, {
                    className: "perPageSelect",
                    id: "perPageSelect",
                    noValueMessage: App.messages.placeholders.empty,
                    optionsFrom: this.options,
                    valueKey: "value",
                    labelKey: "label",
                    onChange: ({ value: val })=>onChange(val),
                    value: value
                })
            ]
        });
    }
    constructor(){
        super();
        this.options = [
            {
                label: '10',
                value: 10
            },
            {
                label: '25',
                value: 25
            },
            {
                label: '50',
                value: 50
            }
        ];
    }
}
_define_property(PerPageSelect, "propTypes", {
    value: PropTypes.number,
    onChange: PropTypes.func
});
_define_property(PerPageSelect, "defaultProps", {
    onChange: ()=>{},
    value: null
});
export default withStyles(styles)(PerPageSelect);
